export enum EEtatRegle {
	valide,
	invalide,
	non_applicable,
	information,
	erreur
}